function pdpVideo() {
    const playBtns = document.querySelectorAll('.video-play-btn');
    playBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const video = e.target.closest('.video-hosted').querySelector('video');
            video.play();
            e.target.closest('button').classList.add('hide');
        })
    })
}

document.addEventListener('DOMContentLoaded', pdpVideo);